import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import shortid from 'shortid';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import JSONPretty from 'react-json-pretty';
import JSONPrettyMon from 'react-json-pretty/dist/monikai';
import { Field, reduxForm, formValueSelector, SubmissionError, submit } from 'redux-form';
import { concat, orderBy, filter, reduce } from 'lodash';
import Joi from 'joi';
import RecipientAutocomplete from '../../pages/DiscoveryBotPage/RecipientAutocomplete';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { sendTestEmail } from '../../../Setup/SetupActions';



const FORM_NAME = 'testEmailForm';
const CHARS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

class TestEmailButton extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      to: [],
      bcc: [],
      cc: [],
      results: null,
      submitted: false,
      id: null,
    };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.renderField = this.renderField.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleToChange = this.handleToChange.bind(this);
    this.handleBCCChange = this.handleBCCChange.bind(this);
    this.handleCCChange = this.handleCCChange.bind(this);
  }


  close() {
    this.props.reset();
    this.setState({ open: false, submitted: false, results: null });
    this.props.onClose();
  }

  open(e) {
    e.preventDefault();
    const id = shortid.generate(CHARS);
    const f = { 
      provider: 'postmark', 
      to: [], bcc: [], cc: [], 
      subject: `TruVoice Automation Test Email [${id}]`,
      message: `TruVoice Automation Test Email [${id}]`,
      id,
    };
    this.props.initialize(f);
    this.setState({ 
      open: true, to: [], bcc: [], cc: [],
      submitted: false, results: null,
      id,
    });
  }

  handleSubmit(data) {
    return this.props.dispatch(sendTestEmail(data))
      .then(
        (results) => {
          this.setState({ submitted: true, results });
        },
        (errors) => {
          const e = errors.data || errors;
          if (e.message) {
            e._error = e.message;
          }
          throw new SubmissionError(e);
        },
      );
  }

  getRecipients(recipients) {
    const users = orderBy(filter(recipients, (r) => { return !r.isEmail; }), ['first_name', 'last_name'], ['asc', 'asc']);
    const emails = orderBy(filter(recipients, (r) => { return r.isEmail; }), ['email'], ['asc']);
    return concat(users, emails);
  }


  handleAddressChange(recipients, field = 'to') {
    const cc = reduce(recipients, (items, recipient) => {
      if (recipient.isEmail) {
        items.push(recipient.email);
      } else {
        items.push(recipient._id);
      }
      return items;
    }, []);
    this.props.change(field, cc);
    const v = this.getRecipients(recipients);
    this.setState({ [field]: v });
  }
  
  handleToChange(recipients) {
    return this.handleAddressChange(recipients, 'to');
  }

  handleBCCChange(recipients) {
    return this.handleAddressChange(recipients, 'bcc');
  }

  handleCCChange(recipients) {
    return this.handleAddressChange(recipients, 'cc');
  }
  
  renderField({
    input, label, type, options, hidden, disabled, componentClass, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label && label !== '' && <ControlLabel>{label}</ControlLabel>}
        {componentClass === 'select' && <FormControl
          {...input}
          componentClass={componentClass}
          type={type}
          disabled={submitting || disabled}
        >
          <option />
          {options.map((o) => {
            return (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            );
          })}
        </FormControl>}
        {componentClass !== 'select' && componentClass !== 'textarea' && hidden !== true && <FormControl
          {...input}
          placeholder={label}
          type={type}
          disabled={submitting || disabled}
        />}
        {componentClass === 'textarea' && <FormControl
          {...input}
          placeholder={label}
          type={type}
          componentClass={componentClass}
          rows={3}
          disabled={submitting || disabled}
        />}
        {hidden !== true && <FormControl.Feedback />}
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }


  renderModal() {
    const {
      error, handleSubmit, submitting, valid,
      organization,
    } = this.props;

    const { submitted } = this.state;
    console.log('this.props', this.props)

    return (
      <Modal show={this.state.open} onHide={this.close} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Send a Test Email</Modal.Title>
        </Modal.Header>
          <form onSubmit={handleSubmit(this.handleSubmit)}>
            {!submitted &&
              <>
                <Modal.Body>
                  <div>
                    {error && <div className="alert alert-danger"><strong>{error}</strong></div>}
                    <Field
                      name="provider"
                      id="provider-field"
                      componentClass="select"
                      component={this.renderField}
                      label="Email Provider"
                      options={[{ label: 'PostMark', value: 'postmark' }, { label: 'SendGrid', value: 'sendgrid' }]}
                    />

                    <Field
                      name="from"
                      id="from-field"
                      type="text"
                      component={this.renderField}
                      label="From Email"
                    />

                    <FormGroup>
                      <ControlLabel>To:</ControlLabel>
                      <RecipientAutocomplete
                        organization={organization}
                        recipients={this.state.to}
                        submitting={submitting}
                        onChange={this.handleToChange}
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>CC:</ControlLabel>
                      <RecipientAutocomplete
                        organization={organization}
                        recipients={this.state.cc}
                        submitting={submitting}
                        onChange={this.handleCCChange}
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>BCC:</ControlLabel>
                      <RecipientAutocomplete
                        organization={organization}
                        recipients={this.state.bcc}
                        submitting={submitting}
                        onChange={this.handleBCCChange}
                      />
                    </FormGroup>
                    
                    <Field
                      name="subject"
                      id="subject-field"
                      type="text"
                      component={this.renderField}
                      label="Subject"
                      disabled
                    />

                    <Field 
                      name="message" 
                      id="message-field"
                      type="text"
                      componentClass="textarea"
                      component={this.renderField}
                      label="Message" 
                      disabled
                    />

                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="clearfix">
                    <div className="pull-left">
                      <Button bsStyle="link" disabled={submitting} onClick={this.close}>
                        <span>Cancel</span>
                      </Button>
                    </div>
                    <div className="pull-right">
                      <Button bsStyle="primary" disabled={submitting || !valid} type="submit">
                        <span>
                          {!submitting && <span><Fa name="send" /> Send</span>}
                          {submitting && <span><Fa name="spinner" spin /> Sending</span>}
                        </span>
                      </Button>
                    </div>
                  </div>
                </Modal.Footer>
              </>
            }
            {submitted &&
              <>
                <Modal.Body>
                  <div>
                    <div className="alert alert-success">Email was sent successfully.</div>
                    <div>
                      <JSONPretty style={{ margin: 0 }} data={this.state.results} theme={JSONPrettyMon} />
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="clearfix">
                    <div className="pull-right">
                      <Button bsStyle="default" onClick={this.close}>
                        <span>Done</span>
                      </Button>
                    </div>
                  </div>
                </Modal.Footer>
              </>
            }
          </form>
  
      </Modal>
    );
  }

  render() {
    const { bsSize } = this.props;
    return (
      <span>
        {this.renderModal()}
        <Button bsSize="xs" bsStyle="default" onClick={this.open}>
          {this.props.children}
        </Button>
      </span>
    );
  }
}

const selector = formValueSelector(FORM_NAME);

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

TestEmailButton.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
  }),
  valid: PropTypes.bool,
  submitting: PropTypes.bool,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  pristine: PropTypes.bool.isRequired,
  children: PropTypes.node,
  bsSize: PropTypes.string,
  submit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
};
TestEmailButton.defaultProps = {
  bsSize: null,
  onClose: () => {},
  submitting: false,
  valid: false,
};

const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   from: {
  //     presence: true,
  //     email: true,
  //   },
  //   subject: {
  //     presence: { allowEmpty: false },
  //     type: 'string',
  //     length: {
  //       minimum: 5,
  //       maximum: 400,
  //     },
  //   },
  //   message: {
  //     presence: { allowEmpty: false },
  //     type: 'string',
  //     length: {
  //       maximum: 2048,
  //     },
  //   },
  //   provider: {
  //     presence: true,
  //     inclusion: ['postmark', 'sendgrid'],
  //   },
  // };

  const schema = Joi.object({
    from: Joi.string().email({ tlds: { allow: false } }).required().messages({
      'string.base': 'From address must be a string',
      'string.empty': 'From address is required',
      'any.required': 'From address is required',
      'string.email': 'From address must be a valid email address',
    }),
    subject: Joi.string().min(5).max(400).required().messages({
      'string.base': 'Subject must be a string',
      'string.empty': 'Subject is required',
      'any.required': 'Subject is required',
      'string.min': 'Subject must be at least 5 characters',
      'string.max': 'Subject must be at most 400 characters',
    }),
    message: Joi.string().max(2048).required().messages({
      'string.base': 'Message must be a string',
      'string.empty': 'Message is required',
      'any.required': 'Message is required',
      'string.max': 'Message must be at most 2048 characters',
    }),
    provider: Joi.string().valid('postmark', 'sendgrid').required().messages({
      'string.base': 'Provider must be a string',
      'any.only': 'Provider must be either postmark or sendgrid',
      'any.required': 'Provider is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};


const TestEmailForm = reduxForm({
  form: FORM_NAME,
  validate,
})(TestEmailButton);

export default connect(mapStateToProps, { submit })(TestEmailForm);
